import axios from 'axios';
import { Message, Loading } from 'element-ui';
import router from '../router';
import store from '../store'
const qs = require('qs');
import { getToken, removeToken } from '@/utils/auth'
import { reLogin } from "@/utils/login";

const pending = [];
const cancelToken = axios.CancelToken
const reloginRequestQueue = []
let isLoggingIn = false;

let loadingCount = 0
let loadingInstance = null

function resolveErrorMessage(error, fallback = '请求失败，请稍后重试') {
  if (!error) {
    return fallback;
  }
  if (typeof error === 'string') {
    return error === 'error' ? fallback : (error || fallback);
  }
  if (axios.isCancel(error)) {
    return '请求已取消，请稍后重试';
  }

  const data = error.response && error.response.data;
  if (data) {
    if (typeof data === 'string' && data.trim()) {
      return data;
    }
    if (typeof data === 'object') {
      const msg = data.errorMsg || data.message || data.msg;
      if (msg) {
        return msg;
      }
    }
  }

  const msg = error.message || '';
  if (!msg || msg === 'error') {
    return fallback;
  }
  if (msg === 'Network Error') {
    return '网络异常，请检查网络后重试';
  }
  if (/timeout/i.test(msg)) {
    return '请求超时，请稍后重试';
  }
  return msg;
}

function normalizeMethod(config) {
  return config && config.method ? String(config.method).toLowerCase() : 'get'
}

function shouldTrackPending(config) {
  if (!config || normalizeMethod(config) !== 'post') {
    return false
  }
  if (config.noPending) {
    return false
  }
  const url = config.url || ''
  if (url === '/file/upload' || url === '/login') {
    return false
  }
  // 分片上传可能同 URL 连续/并行，不做 cancel 防重
  if (url.indexOf('/api/file/chunk/') === 0) {
    return false
  }
  return true
}

function isApproveApiUrl(url) {
  if (!url) {
    return false
  }
  const path = String(url).split('?')[0]
  return /\/api\/.+/i.test(path) && /\/approve$/i.test(path)
}

function shouldShowPostLoading(config) {
  if (!config || config.noLoading || config.silentLoading) {
    return false
  }
  const method = normalizeMethod(config)
  const url = config.url || ''
  if (method === 'post') {
    if (url.includes('/login')) {
      return false
    }
    return true
  }
  // GET /api/*/approve 审批接口
  // if (method === 'get' && isApproveApiUrl(url)) {
  //   return true
  // }
  return false
}

function startPostLoading(config) {
  if (!shouldShowPostLoading(config)) {
    return
  }
  config.__withLoading = true
  if (loadingCount === 0) {
    loadingInstance = Loading.service({
      lock: true,
      text: '正在处理...',
      background: 'rgba(0, 0, 0, 0.35)',
      customClass: 'krj-post-loading',
    })
  }
  loadingCount++
}

function endPostLoading(config) {
  if (!config || !config.__withLoading) {
    return
  }
  config.__withLoading = false
  loadingCount = Math.max(0, loadingCount - 1)
  if (loadingCount === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

// 重复请求处理
const removePending = (config, fn) => {
  // 生成地址加请求方式的唯一值
  const flagUrl = config.url + '&' + config.method
  // 当前请求存在队列中，取消第二次请求
  if (pending.indexOf(flagUrl) !== -1) {
    if (fn) {
      // f为实例化的cancelToken函数
      fn()
    } else {
      pending.splice(pending.indexOf(flagUrl), 1)
      // cancelToken不存在，则从队列中删除该请求
    }
  } else {
    // 当前请求不在队列中，就加进队列
    if (fn) {
      pending.push(flagUrl)
    }
  }
}

// 发起请求前,检查登陆状态
async function checkLoginStatus(config) {
  // 登录信息
  if(!store.getters.userId) {
    if(config.url == '/login') {
      console.log('正在登陆 。。。')
    } else {
      let promise = new Promise((resolve) =>{
        let timer = setInterval(() =>{
          if(store.getters.userId){
            clearInterval(timer)
            resolve()
          }
        },100)
      })
      await promise
    }
  }
}

const service = axios.create({
  // 统一后端入口前缀，如 /server-api；nginx 只需转发该前缀
  baseURL: process.env.VUE_APP_BASE_API || '/',
  withCredentials: true,
  timeout: 100000
});
service.interceptors.request.use(
  (config) => {
    // await checkLoginStatus(config)
    // 请求配置,发送请求
    config.headers['token'] = getToken();
    config.headers['X-FROM'] = 'WEB';
    if (normalizeMethod(config) === 'post') {
      const isFormData = config.data instanceof FormData;
      if (isFormData) {
        delete config.headers['Content-Type'];
        // 大文件上传默认拉长超时（可被单次请求 timeout 覆盖）
        if (config.timeout == null) {
          config.timeout = 600000;
        }
      } else {
        config.headers['Content-Type'] =
          config.headers['Content-Type'] || 'application/json;charset=UTF-8';
      }

      // Check file sizes for upload
      if(isFormData) {
        let totleSize = 0;
        for (const [key, value] of config.data.entries()) {
          if (value instanceof File) {
            totleSize += value.size;
          }
        }
        if (totleSize > 1073741824) {
          return Promise.reject(new Error('上传文件总大小不能超过1G'));
        }
      }

      if (shouldTrackPending(config) && !config.cancelToken) {
        config.cancelToken = new cancelToken(c => {
          removePending(config, c)
        })
      }
    }

    startPostLoading(config)
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    // 解除队列里面的请求
    if (shouldTrackPending(response.config)) {
      removePending(response.config)
    }
    endPostLoading(response.config)
    const res = response.data;
		console.log('AutoConsole: res', res)

    // 验证码功能 判断是否为图片 或者是 ArrayBuffer 数据
    if (res instanceof ArrayBuffer) {
      const buffer = new DataView(res);
      if (ArrayBuffer.isView(buffer)) {
        return res
      }
    }
    if(response.config.url == '/biz/getTemplateCode'){
      return res
    }

    if (!res || typeof res !== 'object' || res.success === undefined) {
      Message.closeAll();
      const invalidMessage = '服务器返回异常，请稍后重试';
      Message({
        message: invalidMessage,
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject(invalidMessage);
    }

    if (!res.success) {
      // 错误处理
      Message.closeAll();

      // token 失效
      if(res.errorCode == "80001" || res.errorCode == "80002") {
        // 实现将需要登陆的请求加入队列，等待登陆成功后按队列重新请求
        var reLoginQueuePromise = new Promise(function (resolve, reject) {
          const retryRequest = () => {
                // 重试时不再重复弹出全屏 loading 叠层问题：沿用默认 POST loading
                const retryConfig = Object.assign({}, response.config)
                delete retryConfig.__withLoading
                delete retryConfig.cancelToken
                service(retryConfig)
                  .then(res => resolve(res))
                  .catch(err => reject(err));
              };
          reloginRequestQueue.push(retryRequest);

          // Trigger login only if not already logging in
          if (!isLoggingIn) {
            reLogin(() => {
              isLoggingIn = false;
              // Execute queued requests after successful login
              while (reloginRequestQueue.length > 0) {
                let requestCallback = reloginRequestQueue.shift();
                if (requestCallback) {
                  requestCallback(); // Re-execute the queued request
                }
              }
            });
            isLoggingIn = true;
          }
        });
        return reLoginQueuePromise;
      }

      const errorMessage = resolveErrorMessage({ message: res.errorMsg });
      Message({
        message: errorMessage,
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject(errorMessage);
    } else {
      return res;
    }
  },
  (error) => {
    console.log('for debug',error); // for debug
    if (error.config) {
      if (shouldTrackPending(error.config)) {
        removePending(error.config);
      }
      endPostLoading(error.config);
    }

    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if(error.response) {
      var status = error.response.status;
      if (status == 500 || status == 502 ) {
        Message({
          message: '服务器访问失败，请稍后再试!',
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject(error);
      }
      if(status == 413) {
        Message({
          message: '上传文件过大，请重新选择文件!',
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject(error);
      }
    }

    const errorMessage = resolveErrorMessage(error);
    Message({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
